/** Optional column.condition from template JSON. */
export type TableColumnVisibleWhen = { field: string; equals: string };

export type TableInputColumn = {
  label?: string;
  value?: string;
  type?: string;
  hideInTable?: boolean;
  visibleWhen?: TableColumnVisibleWhen;
  otherSpecificationField?: string;
  [key: string]: unknown;
};

const isEquipmentOtherSpecifyColumn = (c: TableInputColumn) =>
  c?.value === "equipmentOther" && c?.type === "textInput";

/**
 * “If Other, specify” column: omit from read-only grid (works even if Mongo template lacks hideInTable).
 */
export function isHiddenTableSummaryColumn(c: TableInputColumn): boolean {
  if (c?.hideInTable) return true;
  return isEquipmentOtherSpecifyColumn(c);
}

/**
 * Modal: show “If Other, specify” only when Equipment is Other (template may omit visibleWhen).
 */
export function resolveColumnVisibleWhen(c: TableInputColumn): TableColumnVisibleWhen | undefined {
  if (c?.visibleWhen) return c.visibleWhen;
  if (isEquipmentOtherSpecifyColumn(c)) return { field: "equipment", equals: "Other" };
  return undefined;
}

/** Merge Other + free text in the Equipment summary cell when template omits otherSpecificationField. */
export function resolveOtherSpecificationField(
  c: TableInputColumn
): string | undefined {
  if (c?.otherSpecificationField) return c.otherSpecificationField;
  if (c?.value === "equipment") return "equipmentOther";
  return undefined;
}
